module.exports = __webpack_public_path__ + "static/media/proj1-braves.3d408add.png";